// extracted by mini-css-extract-plugin
export var fadeIn = "_ir-1";
export var modalContent = "_ir-3";
export var overlay = "_ir-0";
export var popoverContent = "_ir-2";
export var results = "_ir-5";
export var searchInputWrapper = "_ir-4";